import React from 'react';
import { Modal, Button, Segment, Dropdown } from 'semantic-ui-react';
import { useIntl } from "react-intl";

interface ModChangeThemeProps {
  open?: boolean;
  size?: string;
  buttonLeft?: string;
  buttonLeftColor?: string;
  onButtonLeftClick?: () => void;
  buttonRight?: string;
  buttonRightColor?: string;
  onButtonRightClick?: () => void;
}

const DEFAULT_PROPS = {
  open: false,
  size: "mini",
  buttonLeft: "ยกเลิก",
  buttonLeftColor: "grey",
  onButtonLeftClick: () => {},
  buttonRight: "ตกลง",
  buttonRightColor: "blue",
  onButtonRightClick: () => {},
}

const ModChangeTheme = (propsParam: ModChangeThemeProps) => {

  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value])=> value !== undefined)),
  };


  const [theme, setTheme] = React.useState("")

  React.useEffect(() => {
    setTheme(props.value)
  }, [props.value])

  const handleSetTheme = (e, { value }) => {
    setTheme(value)
  }

  return (
    <Modal
      open={props.open}
      size={props.size}
    >
      <Segment padded align="center" className="modContent">
        <Dropdown selection options={props.options} value={theme} onChange={handleSetTheme}/>
        <div style={{ marginTop: 20 }}>
          <Button  
            loading={props.buttonLeftLoading} 
            disabled={props.buttonRightLoading}
            color={props.buttonLeftColor} 
            onClick={props.onButtonLeftClick}>
            {props.buttonLeft}
          </Button>
          <Button 
            loading={props.buttonRightLoading} 
            disabled={props.buttonLeftLoading}
            color={props.buttonRightColor} 
            onClick={() => props.onButtonRightClick(theme)}>
            {props.buttonRight}
          </Button>
        </div>
      </Segment>
    </Modal >
  )
} 

export default ModChangeTheme;